export default __webpack_public_path__ + "static/media/LegendaMissionControlG.c99df8fc.svg";